import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import _ from 'lodash'

import NoData from '../../../../../../../../../components/Workspace/components/NoData'

import PublicOfficials from './components/PublicOfficials'
import EndUsers from './components/EndUsers'
import VerificationDocuments from './components/VerificationDocuments'

import { LOCALE_PREFIX } from '../../constants'

import hocConnect from './hocConnect'
import './style.scss'

@injectIntl
@hocConnect
export default class EndUsersSK extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        endUsersData: PropTypes.array,
        endUsersFilter: PropTypes.object,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        level: PropTypes.string.isRequired,
        locked: PropTypes.bool,
        module: PropTypes.string.isRequired,
        publicOfficialsData: PropTypes.array,
        veritifcationDocuments: PropTypes.array,
    }

    render() {
        const {
            id,
            module,
            block,
            level,
            endUsersData,
            endUsersFilter,
            publicOfficialsData,
            veritifcationDocuments,
            intl,
            locked,
        } = this.props

        if (locked) {
            return (
                <div className={'persons-public-officials-block'}>
                    <NoData text={intl.formatMessage({ id: `${LOCALE_PREFIX}.lockedTab` })} />
                </div>
            )
        }

        if (_.isEmpty(publicOfficialsData) && _.isEmpty(endUsersData) && _.isEmpty(endUsersFilter?.activeFilters)) {
            return (
                <div className={'persons-public-officials-block'}>
                    <NoData text={intl.formatMessage({ id: `${LOCALE_PREFIX}.noData` })} />
                </div>
            )
        }

        return (
            <div className={'persons-public-officials-block'}>
                <EndUsers id={id} module={module} block={block} level={level} />
                <VerificationDocuments id={id} intl={intl} documents={veritifcationDocuments} />
                <PublicOfficials id={id} data={publicOfficialsData} />
            </div>
        )
    }
}
